import React, { useState, useRef, useEffect } from 'react';
import './style.scss';
import { Title } from '../../typography/Title/Title';

const AgeSelector = ({ min = 1, max = 99, step = 1, onChange, initialValue }) => {
  const defaultValue = initialValue > 0 ? initialValue : 37;
  const [value, setValue] = useState(defaultValue);
  const rulerRef = useRef(null);
  const stepWidth = 78;

  useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
    }
  }, [initialValue]);

  useEffect(() => {
    if (rulerRef.current) {
      const saved = sessionStorage.getItem('ageSelectorScroll');
      if (saved) {
        rulerRef.current.scrollLeft = parseInt(saved, 10);
      } else {
        const initialScrollLeft = ((defaultValue - min) / step) * stepWidth;
        requestAnimationFrame(() => {
          if (rulerRef.current) {
            rulerRef.current.scrollLeft =
              initialScrollLeft - rulerRef.current.clientWidth / 2 + stepWidth / 2;
          }
        });
      }
    }
  }, []);

  const handleScroll = () => {
    if (rulerRef.current) {
      const scrollLeft = rulerRef.current.scrollLeft;
      sessionStorage.setItem('ageSelectorScroll', scrollLeft);

      const exactValue = Math.max(
        min,
        Math.min(max, Math.round(scrollLeft / stepWidth) * step + min)
      );

      if (exactValue !== value) {
        setValue(exactValue);
        onChange && onChange(exactValue);
      }
    }
  };

  return (
    <div className='age-selector-container'>
      <div ref={rulerRef} onScroll={handleScroll} className='ruler-container'>
        <div
          className='ruler-content'
          style={{
            paddingLeft: `${rulerRef.current ? rulerRef.current.clientWidth / 2 - stepWidth / 2 : 0}px`,
            paddingRight: `${rulerRef.current ? rulerRef.current.clientWidth / 2 - stepWidth / 2 : 0}px`,
          }}
        >
          {Array.from({ length: (max - min) / step + 1 }, (_, i) => {
            const currentValue = min + i * step;
            const isActive = currentValue === value;
            return (
              <div key={i} className={`age-value ${isActive ? 'animated' : ''}`}>
                <Title tag='h3' className={isActive ? 'animated' : ''}>
                  {currentValue}
                </Title>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AgeSelector;
